import * as yup from 'yup';
import { alphabet_numeric_regix, alphabet_regix, iban_ksa_regix, iban_regix, numeric_integer_regix, swift_code_regix } from '../utils/functions';

export const bank_and_custodian_information_schema = (data) => ({
    bankTypeId: data?.bankTypeId ?? null,
    internationalBank: data?.internationalBank ?? [],
    ksaBank: data?.ksaBank ?? [],
    corpClientApplicationCustodianInformationId: data?.corpClientApplicationCustodianInformationId,
    isHaveCustodian: data?.isHaveCustodian ?? null,
    custodianName: data?.custodianName ?? '',
    address: data?.address ?? '',
    accountName: data?.accountName ?? '',
    accountNumber: data?.accountNumber ?? '',
    toWhomShouldWeSendEachOfTheFollowingClient: data?.toWhomShouldWeSendEachOfTheFollowingClient ?? null,
    toWhomShouldWeSendEachOfTheFollowingClientOther: data?.toWhomShouldWeSendEachOfTheFollowingClientOther ?? '',
    toWhomShouldWeSendEachOfTheFollowingDividends: data?.toWhomShouldWeSendEachOfTheFollowingDividends ?? null,
    toWhomShouldWeSendEachOfTheFollowingDividendsOther: data?.toWhomShouldWeSendEachOfTheFollowingDividendsOther ?? '',
    toWhomShouldWeSendEachOfTheFollowingSalesProceeds: data?.toWhomShouldWeSendEachOfTheFollowingSalesProceeds ?? null,
    toWhomShouldWeSendEachOfTheFollowingSalesProceedsOther: data?.toWhomShouldWeSendEachOfTheFollowingSalesProceedsOther ?? '',
});

export const bank_details_schema = (bankTypeId, user) => ({
    bankTypeId,
    bankName: '',
    bankId: null,
    branch: '',
    beneficiaryName: user?.name || '',
    iban: bankTypeId === 1062 ? '' : 'SA',
    accountNumber: '',
    registeredAddress: '',
    abaRoutingNumber: '',
    swiftCode: '',
});

export const bank_details_validation_schema = yup.object().shape({
    bankName: yup
        .string()
        .when('bankTypeId', {
            is: 1062,
            then: (schema) => schema.required('bank_name_required'),
            otherwise: (schema) => schema.nullable(),
        }),
    bankId: yup
        .number()
        .when('bankTypeId', {
            is: 1061,
            then: (schema) => schema.required('bank_required'),
            otherwise: (schema) => schema.nullable(),
        }),
    branch: yup
        .string()
        .required('branch_required')
        .matches(alphabet_regix, 'must_be_characters_only'),

    beneficiaryName: yup
        .string()
        .required('beneficiary_name_required')
        .matches(alphabet_regix, 'must_be_characters_only'),

    iban: yup
        .string()
        .required('iban_required')
        .when('bankTypeId', {
            is: 1061,
            then: (schema) => schema.matches(iban_ksa_regix, 'iban_validation'),
            otherwise: (schema) => schema.matches(iban_regix, 'iban_validation'),
        }),
    accountNumber: yup
        .string()
        .when('bankTypeId', {
            is: 1062,
            then: (schema) => schema.required('account_number_required'),
            otherwise: (schema) => schema,
        }),
    registeredAddress: yup
        .string()
        .when('bankTypeId', {
            is: 1062,
            then: (schema) => schema.required('registered_address_required'),
            otherwise: (schema) => schema,
        }),
    abaRoutingNumber: yup
        .string()
        .when('bankTypeId', {
            is: 1062,
            then: (schema) => schema.required('aba_routing_number_required').matches(numeric_integer_regix, 'aba_routing_number_validation').min(9, 'aba_routing_number_validation').max(9, 'aba_routing_number_validation'),
            otherwise: (schema) => schema,
        }),
    swiftCode: yup
        .string()
        .when('bankTypeId', {
            is: 1062,
            then: (schema) =>
                schema
                    .required('swift_code_required')
                    .matches(swift_code_regix, 'swift_code_validation'),
            otherwise: (schema) => schema,
        }),
});

export const bank_and_custodian_information_validation_schema = yup.object().shape({
    bankTypeId: yup
        .number()
        .nullable(),
    custodianName: yup
        .string()
        .matches(alphabet_regix, 'must_be_characters_only')
        .nullable(),
    // .when('isHaveCustodian', {
    //     is: true,
    //     then: (schema) => schema.required('custodian_name_required'),
    //     otherwise: (schema) => schema.nullable(),
    // }),
    address: yup
        .string()
        .nullable(),
    // .when('isHaveCustodian', {
    //     is: true,
    //     then: (schema) => schema.required('address_required'),
    //     otherwise: (schema) => schema.nullable(),
    // }),
    accountName: yup
        .string()
        .matches(alphabet_regix, 'must_be_characters_only')
        .nullable(),
    // .when('isHaveCustodian', {
    //     is: true,
    //     then: (schema) => schema.required('account_name_required').,
    //     otherwise: (schema) => schema.nullable(),
    // }),
    accountNumber: yup
        .string()
        .matches(numeric_integer_regix, 'must_be_digits_only')
        .nullable(),
    // .when('isHaveCustodian', {
    // is: true,
    // then: (schema) => schema.required('account_number_required').,
    // otherwise: (schema) => schema.nullable(),
    // }),
    toWhomShouldWeSendEachOfTheFollowingClient: yup
        .number()
        .nullable(),
    // .required('to_whom_should_we_send_each_of_the_following_client_required'),
    toWhomShouldWeSendEachOfTheFollowingClientOther: yup
        .string()
        .nullable(),
    // .when('toWhomShouldWeSendEachOfTheFollowingClient', {
    //     is: 803,
    //     then: (schema) => schema.required('field_is_required'),
    //     otherwise: (schema) => schema,
    // }),
    toWhomShouldWeSendEachOfTheFollowingDividends: yup
        .number()
        .nullable(),
    // .required('to_whom_should_we_send_each_of_the_following_dividends_required'),
    toWhomShouldWeSendEachOfTheFollowingDividendsOther: yup
        .string()
        .nullable(),
    // .when('toWhomShouldWeSendEachOfTheFollowingDividends', {
    //     is: 803,
    //     then: (schema) => schema.required('field_is_required'),
    //     otherwise: (schema) => schema,
    // }),
    toWhomShouldWeSendEachOfTheFollowingSalesProceeds: yup
        .number()
        .nullable(),
    // .required('to_whom_should_we_send_each_of_the_following_sales_proceeds_required'),
    toWhomShouldWeSendEachOfTheFollowingSalesProceedsOther: yup
        .string()
        .nullable(),
    // .when('toWhomShouldWeSendEachOfTheFollowingSalesProceeds', {
    //     is: 803,
    //     then: (schema) => schema.required('field_is_required'),
    //     otherwise: (schema) => schema,
    // }),
});
